module.exports = __webpack_public_path__ + "img/1477228457.72978a45.jpg";